<div class="header">
  <div class="header-title">
    <h2>{{ "pages.usage.title" | translate }}</h2>
    <button
      nbButton
      status="primary"
      class="btn btn-primary"
      outline=""
      (click)="refresh()"
    >
      <nb-icon icon="refresh-outline"></nb-icon>
      {{ "buttons.refresh" | translate }}
    </button>
  </div>

  <p class="period">{{ getUsagePeriod() }}</p>
</div>

<div class="total-usage" *ngIf="apiUsage">
  <!-- Credits: same tiles as the other quotas. Plan credits renew every
       period; purchased credits carry over until their expiry date. -->
  <nb-card *ngIf="creditPricing">
    <nb-card-body>
      <div class="card-content">
        <div class="icon {{ planCreditsStatus }}">
          <nb-icon status="control" icon="flash-outline" />
        </div>
        <div class="text">
          <p>
            {{ "pages.usage.credits.plan" | translate }}
            <nb-icon
              class="tile-info"
              icon="info-outline"
              [nbTooltip]="'pages.usage.credits.planTip' | translate"
              nbTooltipPlacement="top"
            ></nb-icon>
          </p>
          <h3 *ngIf="planCreditsIncluded !== null">
            {{ planCreditsRemaining | number : "1.0-0" }}/{{ planCreditsIncluded | number : "1.0-0" }}
          </h3>
          <h3 *ngIf="planCreditsIncluded === null">
            {{ "pages.organisation.credits.unlimited" | translate }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="creditPricing">
    <nb-card-body>
      <div class="card-content">
        <div class="icon success">
          <nb-icon status="control" icon="plus-circle-outline" />
        </div>
        <div class="text">
          <p>
            {{ "pages.usage.credits.purchased" | translate }}
            <nb-icon
              class="tile-info"
              icon="info-outline"
              [nbTooltip]="purchasedCreditsTip"
              nbTooltipPlacement="top"
            ></nb-icon>
          </p>
          <h3>{{ purchasedCredits | number : "1.0-0" }}</h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
            getStatus(
              getPercentage(
                usage.file_usage.current_count,
                usage.file_usage.quota_limit
              )
            )
          }}"
        >
          <nb-icon status="control" icon="hard-drive-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.diskUsageLabel" | translate }}</p>
          <h3>
            {{ getMegaBytes(usage.file_usage.current_count) | number : "1.0-2" }}/{{
              getMegaBytes(usage.file_usage.quota_limit) | number : "1.0-2"
            }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
              getStatus(
              moodleCourseUsage.current_count,
              moodleCourseUsage.quota_limit
            )
          }}"
        >
          <nb-icon status="control" icon="book-open-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.moodleCourseLabel" | translate }}</p>
          <h3>
            {{ moodleCourseUsage.current_count }}/{{
              moodleCourseUsage.quota_limit
            }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <!-- Anfragen-Kachel entfernt (2026-09-20): `request_quota` wird nirgends
       durchgesetzt. Die einzige Pruefung liegt in der toten
       `utils.track_websocket_interaction_old`; die aktive Fassung gibt
       `remaining_quota: None` zurueck. Eine Zahl anzuzeigen, hinter der keine
       Grenze steht, laedt zu falschen Schluessen ein. Verbindlich sind das
       Token-Kontingent und kuenftig die Credits. -->

  <!-- Token tile: backup view, switched off (showLegacyTokenUsage). -->
  <nb-card *ngIf="showLegacyTokenUsage">
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
            getStatus(apiUsage.token_usage_count, apiUsage.token_quota_limit)
          }}"
        >
          <nb-icon status="control" icon="message-square-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.tokensLabel" | translate }}</p>
          <h3>
            {{ formatNumber(apiUsage.token_usage_count) }}/{{
              formatNumber(apiUsage.token_quota_limit)
            }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
            getStatus(
              usage.document_usage.current_count,
              usage.document_usage.quota_limit
            )
          }}"
        >
          <nb-icon status="control" icon="file-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.fileLabel" | translate }}</p>
          <h3>
            {{ usage.document_usage.current_count }}/{{
              usage.document_usage.quota_limit
            }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
            getStatus(
              usage.url_usage.current_count,
              usage.url_usage.quota_limit
            )
          }}"
        >
          <nb-icon status="control" icon="globe-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.urlLabel" | translate }}</p>
          <h3>
            {{ usage.url_usage.current_count }}/{{
              usage.url_usage.quota_limit
            }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card>
    <nb-card-body>
      <div class="card-content">
        <div
          class="icon {{
            getStatus(apiUsage.search_usage_count, apiUsage.search_quota_limit)
          }}"
        >
          <nb-icon status="control" icon="search-outline" />
        </div>
        <div class="text">
          <p>{{ "pages.usage.webSearchLabel" | translate }}</p>
          <h3>
            {{ apiUsage.search_usage_count }}/{{ apiUsage.search_quota_limit }}
          </h3>
        </div>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<div class="credit-links" *ngIf="creditPricing">
  <a routerLink="/analytics/credits" *ngIf="canSeeCreditDetails">{{ "pages.usage.credits.details" | translate }}</a>
  <a routerLink="/organisation" *ngIf="authService.isAdmin()">{{ "pages.usage.credits.manage" | translate }}</a>
</div>

<div class="header">
  <h4>
    {{ "pages.usage.apiKeysTitle" | translate }}
  </h4>

  <div class="api-actions">
    @if(authService.hasAccess(authService.UserAccess.UsageEditApiKey)){

    <button
      nbButton
      status="primary"
      outline=""
      class="btn btn-primary"
      (click)="editWhitelist()"
    >
      <nb-icon icon="globe-outline"></nb-icon>
      {{ "buttons.domainWhitelist" | translate }}
    </button>

    <button
      nbButton
      status="primary"
      class="btn btn-primary"
      (click)="addApiKey()"
    >
      <nb-icon icon="plus"></nb-icon> {{ "buttons.add" | translate }}
    </button>
    }
  </div>
</div>
<div class="table-container">
  <nb-card>
    <nb-card-body [style]="{ padding: 0 }">
      <table class="al-table">
        <table>
          <thead>
            <tr>
              <th>{{ "words.name" | translate }}</th>
              <th>{{ "words.createdAt" | translate }}</th>
              <!-- <th>Key</th> -->
              <th *ngIf="showLegacyTokenUsage">{{ "words.usage" | translate }}</th>
              <th [width]="50"></th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let a of apiKeys">
              <td>{{ a.name }}</td>
              <td>{{ a.created_at | date : "short" : "CET" }}</td>
              <!-- <td>{{ a.clear_api_key }}</td> -->
              <td width="30%" *ngIf="showLegacyTokenUsage">
                <div class="api-key-progress">
                  <nb-progress-bar
                    nbPopover="{{
                      'popovers.usedTokens'
                        | translate
                          : {
                              value:
                                getProgress(
                                  a.remaining_token_quota,
                                  a.token_quota_limit
                                ) +
                                '% (' +
                                formatNumber(
                                  a.token_quota_limit - a.remaining_token_quota
                                ) +
                                ')'
                            }
                    }}"
                    nbPopoverTrigger="hover"
                    nbPopoverPlacement="left"
                    [value]="
                      getProgress(a.remaining_token_quota, a.token_quota_limit)
                    "
                    [status]="
                      getStatus(
                        a.token_quota_limit - a.remaining_token_quota,
                        a.token_quota_limit
                      )
                    "
                    [displayValue]="
                      getProgress(
                        a.remaining_token_quota,
                        a.token_quota_limit
                      ) > 30
                    "
                  ></nb-progress-bar>
                </div>
              </td>
              <td>
                <div class="actions">
                  <button
                    nbButton
                    status="primary"
                    ghost=""
                    (click)="copyApiKey(a)"
                  >
                    <nb-icon icon="copy-outline"></nb-icon>
                  </button>
                  <button nbButton status="primary" (click)="showEmbedding(a)">
                    <nb-icon icon="code-outline"></nb-icon>
                  </button>
                  @if(authService.hasAccess(authService.UserAccess.UsageEditApiKey)){
                  <button
                    nbButton
                    status="danger"
                    class="btn btn-danger"
                    (click)="deleteApiKey(a)"
                    *ngIf="apiKeys.length > 1"
                  >
                    <nb-icon icon="trash-2"></nb-icon>
                  </button>
                  }
                </div>
              </td>
            </tr>
            <tr *ngIf="apiKeys.length === 0">
              <td colspan="5" class="text-center">
                {{ "pages.usage.noApiKeys" | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </table>
    </nb-card-body>
  </nb-card>
</div>
